<template>
  <v-container fluid>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay-loader :status="status" />
    <v-row class="mx-10 mb-4">
      <v-col cols="12" class="d-flex ma-0 pa-0 justify-end">
        <span class="mr-4 text-caption"> Puntos: </span>
        <span class="mr-2 text-caption"> Profesional: {{ tokensInstProfes }}  ,</span>
        <span class="ml-1 text-caption"> Anamnesis: {{ tokensAnamnesis }} </span>
      </v-col>
    </v-row>
    <v-row class="mx-10 mt-4 justify-center">
      <div class="text-body-2 justify-center mt-1" style="text-align: justify;">
        Esta herramienta permite generar automáticamente un informe psicológico a partir de la información recopilada en la anamnesis. El sistema organiza los datos en un formato estructurado y listo para su impresión.
        Podrás utilizar el informe tal como se genera o, si lo prefieres, agregar observaciones adicionales en cada sección temática para complementar la evaluación clínica según tu criterio profesional.
        También puedes utilizar las funciones de regenerar, parafrasear y sintetizar, incluyendo entre llaves { } la instrucción que deseas aplicar en la redacción. Ten en cuenta que estas acciones generarán un recargo de puntos, el cual se descontará de los puntos asignados inicialmente tanto a la anamnesis como al profesional.
      </div>
      <v-btn
        color="grey darken-3"
        class="d-flex mx-auto mt-2 justify-center grey--text"
        @click="generateReportBtn"
      >
        GENERAR
      </v-btn>
      <v-dialog v-model="confirmDialog.visible" max-width="500">
        <v-card>
          <v-card-title class="headline">{{ confirmDialog.title }}</v-card-title>
          <v-card-text class="text-body-1">{{ confirmDialog.message }}</v-card-text>
          <v-card-actions class="justify-end">
            <v-btn color="grey" text @click="confirmDialog.visible = false">
              Cancelar
            </v-btn>
            <v-btn color="primary" class="mb-2 mr-3" @click="onConfirmGenerateReport">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row class="mx-12 mt-14 mb-2">
      <v-col class="d-flex mt-3 ma-0 pa-0 justify-start">
        <v-btn @click="scrollToBottom()" x-small depressed rounded>Bajar</v-btn>
      </v-col>
      <v-col class="d-flex ma-0 pa-0 justify-end">
        <v-btn color="primary" class="mr-6" medium @click="downloadReport"> Descargar PDF </v-btn>
        <v-btn color="primary" class="mr-3" medium @click="save"> Guardar </v-btn>
      </v-col>
      <v-snack-bar :snackbar="snackbar" />
    </v-row>
    <v-card class="mx-12 justify-center rounded-lg" style="border: 3px solid #82B1FF; border-radius: 8px;">
      <v-row class="mx-2 justify-center">
        <v-col cols="12">
          <v-card-title class="mx-auto mt-3 mb-5 justify-center text-subtitle-1 font-weight-bold black--text"> INFORME PSICOLÓGICO </v-card-title>
          <v-card-subtitle class="mx-auto pb-2 justify-start text-subtitle-2 font-weight-bold black--text"> I.	DATOS DE FILIACIÓN </v-card-subtitle>
          <v-card-text class="ml-8 justify-end text--body-1" style="width: 96%; border: 1px solid grey; border-radius: 2px;">
            <v-row class="mt-1">
              
              <v-col cols="12" md="6">
                <v-col cols="12" class="py-0">
                  <span class="font-weight-medium">Edad: </span>
                  <span v-if="filiationData?.filiation_age_evaluation">
                    {{ filiationData.filiation_age_evaluation }} 
                  </span>
                </v-col>

                <v-col cols="12" class="py-0">
                  <span class="font-weight-medium">Fecha de Nacimiento: </span>
                  <span> </span>
                </v-col>

                <v-col cols="12" class="py-0">
                  <span class="font-weight-medium">Sexo de Nacimiento: </span>
                  <span v-if="userData">
                    {{ userData.users_birth_sexes }}
                  </span>
                </v-col>

                <v-col cols="12" class="py-0">
                  <span class="font-weight-medium">Estado Civil</span>
                  <span v-if="filiationData">
                    {{ filiationData.filiMaritalStatus?.marital_status }}
                  </span>
                </v-col>
                <v-col cols="12" class="py-0">
                  <span class="font-weight-medium">Grado de Instrucción: </span>
                  <span v-if="filiationData?.filiInstructionLevels">
                    {{ filiationData.filiInstructionLevels.instruction_levels }}
                  </span>
                </v-col>
                <v-col cols="12" class="py-0">
                  <span class="font-weight-medium">Profesión: </span>
                  <span v-if="filiationData?.filiCareers">
                    {{ filiationData.filiCareers.careers }}
                  </span>
                </v-col>
                <v-col cols="12" class="py-0">
                  <span class="font-weight-medium">Ocupación: </span>
                  <span v-if="filiationData?.filiOccupation">
                    {{ filiationData.filiOccupation.occupation }}
                  </span>
                </v-col>
                <v-col cols="12" class="py-0">
                  <span class="font-weight-medium">Informantes: </span>
                  <span v-if="filiationData?.filiationInformant && filiationData.filiationInformant.length">
                    {{ formatInformants(filiationData.filiationInformant) }}
                  </span>
                </v-col>
              </v-col>
              <v-col cols="12" md="6">
                <v-col cols="12" class="py-0">
                  <span class="font-weight-medium">N° Pat:</span>
                  <span>
                    {{ userData.patients_npat_prefix }}-{{ userData.patients_npat }}
                  </span>
                </v-col>
                <v-col cols="12" class="py-0">
                  <span class="font-weight-medium">N° HCP (Psyc.P): </span>
                  <span v-if="userData">
                    {{ userData.clinicalHistories_hcp }}
                  </span>
                </v-col>
                <v-col cols="12" class="py-0">
                  <span class="font-weight-medium">N° HC Institucional: </span>
                  <span v-if="filiationData?.institution_hcp_num">
                    {{ filiationData.institution_hcp_num }}
                  </span>
                </v-col>
                 <v-col cols="12" class="py-0">
                  <span class="font-weight-medium">Fecha de HCP: </span>
                  <span v-if="filiationData?.hcp_date">
                    {{ formatHCPDate(filiationData.hcp_date) }}
                  </span>
                </v-col>
                 <v-col cols="12" class="py-0">
                  <span class="font-weight-medium">Evaluador: </span>
                  <span v-if="filiationData?.hcp_date">
                    ****** ****** ******
                  </span>
                </v-col>
                
              </v-col>
            </v-row>
          </v-card-text>

          <v-form-base
            v-if="modelForm && Object.keys(modelForm).length > 0"
            :schema="schema.schemaForm"
            :model="modelForm"
            @input="handleEvents"
            @click="handleEventsBtn"
            class="d-flex justify-center mt-6 mb-6 mx-4"
          />      
        </v-col>
      </v-row>
    </v-card>
    <span class="text-body-2 text--secondary ml-14">
      Nota: El formato mostrado aquí es una vista previa. Al descargar el pdf, el informe se genera con un formato más completo.
    </span>
    <v-row class="mx-12 mt-2 mb-3">
      <v-col class="d-flex mt-4 ma-0 pa-0 justify-start">
        <v-btn @click="scrollToTop()" x-small depressed rounded>Subir</v-btn>
      </v-col>
      <v-col class="d-flex mt-4 ma-0 pa-0 justify-end">
        <v-btn color="primary" class="mr-6" medium @click="downloadReport"> Descargar PDF </v-btn>
        <v-btn color="primary" class="mr-3" medium @click="save"> Guardar </v-btn>
      </v-col>
      <v-overlay v-model="overlay" style="z-index: 1000; position: absolute; align-items: flex-start;">
        <v-row class="my-16 pt-10" style="width: 200px">
          <v-col cols="12" class="ma-0 pa-0 mt-16">
            <span class="d-flex text-subtitle-1 justify-center text-black mt-16">Procesando</span>
          </v-col>
          <v-col cols="12">
            <v-progress-linear class="mx-auto" indeterminate rounded height="7"></v-progress-linear>
          </v-col>
        </v-row>
      </v-overlay>
      <v-snack-bar :snackbar="snackbar" />
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VFormBase from 'vuetify-form-base';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'ProPatientsCReportPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VOverlayLoader,
    VFormBase,
    VSnackBar
  },
  data() {
    return {
      overlay: false,
      overlayMessage: '',
      confirmDialog: {
        visible: false,
        title: 'Confirmar generación de informe',
        message: 'La nueva información reemplazará la existente, incluyendo la que agregaste manualmente. ¿Deseas continuar?',
      },
    };
  },
    computed: {
    ...mapGetters('proPatientsCReport', ['schema', 'isNewRecord', 'status', 'modelForm', 'tokensInstProfes', 'tokensAnamnesis', 'userData', 'filiationData']),
    ...mapGetters('anamPermissions', ['anamIndex', 'anamGroupShow','hasPermission', 'observerHCP']),
    ...mapGetters('notifications', ['snackbar']),

    patientUser() {
      const raw = this.userData?.professionalHasPatients?.patient?.user;
      return raw ? JSON.parse(JSON.stringify(raw)) : null;
    }
  },

  mounted() {
    this.loadData();
  },

  methods: {
    ...mapActions('proPatientsCReport', [
      'fetchSchema',
      'fetchRecords',
      'generateReport',
      'updateRecord',
      'exportReport',
    ]),
    ...mapActions('anamPermissions', ['loadPermissionsHCP', 'loadObserverHCP']),
    ...mapActions('anamPermissions', ['sectionsHCPandRoute', 'checkPermission', 'loadObserverHCP']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      try {
        await Promise.all([
          this.fetchSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);

        if (this.hasPermission) {
          await this.fetchRecords();
        } else {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      }
    },

    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },

    generateReportBtn() {
      this.confirmDialog.visible = true;

      if (!this.filiationData?.hcp_date) {
        this.snackbar.visible = false;
        this.snackbar.content = "Completar 'Filiación' de la Anamnesis como mínimo, o Fecha de HCP.";
        this.snackbar.visible = true;
        this.confirmDialog.visible = false;
        return;
      }
    },

    async onConfirmGenerateReport() {
      try {
        this.confirmDialog.visible = false;

        if (this.tokensInstProfes === 0 && this.tokensAnamnesis === 0) {
          this.snackbar.visible = false;
          this.snackbar.content = 'No tiene suficientes puntos.';
          this.snackbar.visible = true;
          return;
        }

        this.overlayMessage = 'Generando informe, por favor espere...';
        this.overlay = true;

        const action = 'generateReport';
        const part = "all_report";
        await this[action]({part});

        this.overlay = false;
        this.overlayMessage = '';

        if (this.status === 'success') {
          this.snackbar.visible = false;
          this.snackbar.content = 'El informe se generó correctamente.';
          this.snackbar.color = 'success';
          this.snackbar.visible = true;
        }

        await this.fetchRecords();

      } catch (error) {
        this.overlay = false;
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackError || 'Error inesperado.'),
          'error'
        );
      }
    },

    handleEventsBtn(event) {
      const part = event.key;

      if (part.includes("save")) {
        this.save()
      } else {
        let partChange = part.replace(/^(paraphrase_|regenerate_|synthesize_)/, "report_");

        let sectionTextChange = event.data[partChange];
        this.processPartReport(part, sectionTextChange);
      }
    },

    async processPartReport(part, sectionTextChange) {
      try {
        this.confirmDialog.visible = false;

        if (this.tokensInstProfes === 0 && this.tokensAnamnesis === 0) {
          this.snackbar.visible = false;
          this.snackbar.content = 'No tiene suficientes puntos.';
          this.snackbar.visible = true;
          return;
        }

        this.overlayMessage = 'Generando parte del informe, por favor espere...';
        this.overlay = true;

        const action = 'generateReport';
        await this[action]({part, sectionTextChange});

        this.overlay = false;
        this.overlayMessage = '';

        if (this.status === 'success') {
          this.snackbar.visible = false;
          this.snackbar.content = 'Esta parte del informe se generó correctamente.';
          this.snackbar.color = 'success';
          this.snackbar.visible = true;
        }

        await this.fetchRecords();

      } catch (error) {
        this.overlay = false;
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackError || 'Error inesperado.'),
          'error'
        );
      }
    },

    async save() {
      try {
        const model = {
          modelForm: this.modelForm
        };
        const action = 'updateRecord';
        await this[action]({ model });

        const message =
          this.status === 'success'
            ? this.sanitizeText(this.schema?.snackOk || 'Guardado correctamente.')
            : this.sanitizeText(this.schema?.snackError || 'Error al guardar.');

        this.showSnackbar(message, this.status === 'success' ? 'success' : 'error');

        this.fetchRecords();
      } catch (error) {
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackError || 'Error inesperado.'),
          'error'
        );
      }
    },

    async downloadReport() {
      try {
        this.overlayMessage = 'Descargando informe, por favor espere...';
        this.overlay = true;

        const action = 'exportReport';
        await this[action]();

        this.overlay = false;
        this.overlayMessage = '';

        if (this.status === 'loaded') {
          this.snackbar.visible = false;
          this.snackbar.content = 'El informe se descargó correctamente.';
          this.snackbar.color = 'success';
          this.snackbar.visible = true;
        }

      } catch (error) {
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackError || 'Error inesperado.'),
          'error'
        );
      }
    },    

    handleEvents() {},

    handleDataError(error, message) {
      console.error(message, error);
      this.showSnackbar(message, 'error');
    },

    showSnackbar(content, color) {
      this.triggerSnackbar({ content, color });
    },

    sanitizeText(text) {
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },

    formatBirthDate(dateString) {
      if (!dateString) return '';

      const [year, month, day] = dateString.split('-');
      const birthDate = new Date(year, month - 1, day);

      const formattedDate = birthDate.toLocaleDateString('es-PE', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });

      return formattedDate;
    },

    calculateAge(dateString) {
      if (!dateString) return '';

      const birthDate = new Date(dateString);
      const now = new Date();

      let ageYears = now.getFullYear() - birthDate.getFullYear();
      let ageMonths = now.getMonth() - birthDate.getMonth();

      if (ageMonths < 0) {
        ageYears--;
        ageMonths += 12;
      }

      return `${ageYears} años, ${ageMonths} meses`;
    },

    formatInformants(informants) {
      if (!Array.isArray(informants) || informants.length === 0) return '';

      return informants
        .map(info => {
          const name = info.informant_name || '';
          const bond = info.filiInformantBond?.bond || '';
          return bond ? `${name} (${bond})` : name;
        })
        .join(', ');
    },

    formatHCPDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date)) return '';
      return date.toLocaleDateString('es-PE', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    },

    formatFullName(user) {
      if (!user) return '';
      const surnames = [user.users_first_surname, user.users_second_surname].filter(Boolean).join(' ');
      const names = [user.users_first_name, user.users_second_name, user.users_third_name].filter(Boolean).join(' ');
      return `${surnames}${surnames && names ? ', ' : ''}${names}`.trim();
    },

    scrollToBottom() {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,      
        behavior: 'smooth'  
      });
    }
  },
};
</script>

<style>

.contentCentral {
  width: 100%;
}

.contentCardCentral {
  width: 100%;
  margin-top: 10px;
}

.contentRowCentral {
  width: 80%;
  min-height: 390px;
}

.contentForm {
  min-height: 390px;
}

.contentList {
  width: 700px;
}

.bannerAction {
  width: 87%;
  height: 48px;
}

.placeholderColor input::placeholder {
  color: black !important;
  font-size: 0.85rem;
  opacity: 1;
}

.placeholderStyle .v-label {
  color: black !important;
  font-size: 1.15rem;
  font-weight: 500;
  opacity: 1 !important;
}

.textarea-top-padding .v-input__slot textarea {
  padding-top: 8px; 
  padding-bottom: 8px; 
  text-align: justify !important;
}

</style>